(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('id-menu-drawer')) {
    class IdMenuDrawer extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-drawer-toggle]');
        this.badge = this.querySelector('[data-cart-badge]');
        this.root = this.querySelector('[data-drawer-root]');
        if (!this.toggle || !this.root) return;

        this.panel = this.root.querySelector('.id-drawer');
        this.onKeydown = this.onKeydown.bind(this);

        this.toggle.addEventListener('click', () => (this.isOpen ? this.close() : this.open()));
        this.root.querySelectorAll('[data-drawer-close]').forEach((el) => el.addEventListener('click', () => this.close()));
        this.root.addEventListener('keydown', this.onKeydown);

        // Move the drawer to <body> so the sticky/animated header can't clip a fixed panel.
        document.body.appendChild(this.root);

        this.watchCart();
      }

      disconnectedCallback() {
        if (this.cartObserver) this.cartObserver.disconnect();
        if (this.root && this.root.parentNode === document.body) this.root.remove();
        document.documentElement.classList.remove('id-drawer-lock');
      }

      get isOpen() {
        return this.root && this.root.classList.contains('is-open');
      }

      open() {
        this.lastFocus = document.activeElement;
        this.root.classList.add('is-open');
        this.toggle.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('id-drawer-lock');
        requestAnimationFrame(() => {
          const closeBtn = this.panel.querySelector('.id-drawer__close');
          (closeBtn || this.panel).focus({ preventScroll: true });
        });
      }

      close() {
        if (!this.isOpen) return;
        this.root.classList.remove('is-open');
        this.toggle.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('id-drawer-lock');
        (this.lastFocus && this.lastFocus.focus ? this.lastFocus : this.toggle).focus({ preventScroll: true });
      }

      onKeydown(event) {
        if (!this.isOpen) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }
        if (event.key !== 'Tab') return;

        const focusable = Array.from(
          this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, summary, [tabindex]:not([tabindex="-1"])')
        ).filter((el) => el.offsetParent !== null);
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      // Mirror the cart count (updated by cart-notification.js / cart.js) onto the burger badge.
      watchCart() {
        const bubble = document.getElementById('cart-icon-bubble');
        if (!bubble || !this.badge) return;
        const sync = () => {
          const countEl = bubble.querySelector('.cart-count-bubble');
          const badges = document.querySelectorAll('[data-cart-badge]');
          if (!countEl) {
            badges.forEach((b) => { b.hidden = true; b.textContent = ''; });
            return;
          }
          const n = countEl.querySelector('[aria-hidden="true"]');
          const text = n ? n.textContent.trim() : '99+';
          badges.forEach((b) => { b.textContent = text; b.hidden = false; });
        };
        this.cartObserver = new MutationObserver(sync);
        this.cartObserver.observe(bubble, { childList: true, subtree: true, characterData: true });
      }
    }
    customElements.define('id-menu-drawer', IdMenuDrawer);
  }

  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky =
          this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};

        this.setHeaderHeight();
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

        this.currentScrollTop = 0;
        this.preventReveal = false;

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        const observer = new IntersectionObserver((entries, obs) => {
          this.headerBounds = entries[0].intersectionRect;
          obs.disconnect();
        });
        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const drawer = this.querySelector('id-menu-drawer');
        if (drawer && drawer.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
    }
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
